import * as api from "../apis/interestGroupsApi";
import {
  useQuery,
  useQueryClient,
  queryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";


// Query options

export const getInterestGroupsQueryOptions = () => {
  return queryOptions({
    queryKey: ["interestGroups"],
    queryFn: api.getInterestGroups,
    refetchOnWindowFocus: "always",
    
  });
};

export const getInterestGroupsByAdPlatformQueryOptions = (
  adPlatformId,
  queryClient
) =>
  queryOptions({
    queryKey: ["adPlatform.interestGroups", adPlatformId],
    queryFn: () => api.getInterestGroupsByAdPlatform(adPlatformId),
    refetchOnWindowFocus: "always",
    
    initialData: () =>
      queryClient
        .getQueryData(["interestGroups"])
        ?.filter((interestGroup) => interestGroup.adPlatform?.id === adPlatformId),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["interestGroups"])?.dataUpdatedAt,
  });

export const getInterestGroupQueryOptions = (id, queryClient) => {
  let queryKey;

  return queryOptions({
    queryKey: ["interestGroup", id],
    queryFn: () => api.getInterestGroup(id),
    refetchOnWindowFocus: "always",
    
    initialData: () => {
      // if "interestGroups" query exist, we use it to init data
      if (queryClient.getQueryState(["interestGroups"])) {
        queryKey = ["interestGroups"];
        return queryClient
          .getQueryData(["interestGroups"])
          ?.find((interestGroup) => interestGroup.id === id);
      }

      // otherwise, we try to find the interestGroup in one of the "adPlatform.interestGroups" queries
      let found;

      queryClient
        .getQueriesData({ queryKey: ["adPlatform.interestGroups"] })
        .forEach((query) => {
          const data = query[1];
          data.forEach((interestGroup) => {
            if (interestGroup.id === id) {
              found = interestGroup;
              queryKey = query[0];
            }
          });
        });

      return found;
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
};

// useQuery

export const useGetInterestGroups = () => useQuery(getInterestGroupsQueryOptions());

export const useGetInterestGroup = (id) => {
  const queryClient = useQueryClient();
  return useQuery(getInterestGroupQueryOptions(id, queryClient));
};

// useSuspenseQuery

export const useSuspenseGetInterestGroups = () => {
  return useSuspenseQuery(getInterestGroupsQueryOptions());
};

export const useSuspenseGetInterestGroupsByAdPlatform = (adPlatformId) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(
    getInterestGroupsByAdPlatformQueryOptions(adPlatformId, queryClient)
  );
};

export const useSuspenseGetInterestGroup = (id) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getInterestGroupQueryOptions(id, queryClient));
};
